export default __webpack_public_path__ + "static/media/middle_of_curl.2759af13.svg";